export const cardContainer = {
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  '& .rccs__card--unknown > div': {
    backgroundColor: '#9FBABE !important'
  }
};
